// extracted by css-extract-rspack-plugin
var _1 = "badge-opRW4u";
var _2 = "copy-iQ0sOn";
var _3 = "panel-YHWpv0";
var _4 = "title-SLtGTC";
export { _1 as "badge", _2 as "copy", _3 as "panel", _4 as "title" }
